module.exports = __webpack_public_path__ + "static/media/RecomendaCUritiba.8b7f8fb0.jpg";